@if (showModal) {
  <kendo-dialog
    title="Help Desk"
    id="help-desk-modal"
    #helpDeskModal
    (close)="cancel()"
    [width]="600"
  >
    <!-- WI 35852: a div, not a form. Without NgForm a <form> would submit
         natively (page reload) when Enter is pressed in a field. -->
    <div>
      @if (!isSaving) {
        <!-- Common Fields -->
        <div class="form-group">
          <label>Name:</label>
          <input
            id="ticketName"
            help-anchor="ticketName"
            class="form-control autogrow transition-height"
            [formField]="f.fullName"
          />
          <label>Email:</label>
          <input
            id="ticketEmail"
            help-anchor="ticketEmail"
            class="form-control autogrow transition-height"
            [formField]="f.email"
          />
        </div>

        <!-- Ticket Type Selector -->
        <div class="form-group">
          <label>
            <i class="k-icon k-i-tell-a-friend me-1"></i>
            Ticket Type:
          </label>
          <select
            id="ticketTypeId"
            help-anchor="ticketTypeId"
            class="form-control"
            [formField]="f.ticketTypeId"
          >
            <option value="" disabled selected>Select Ticket Type</option>
            <option value="Incident">Incident</option>
            <option value="Request">Service Request</option>
          </select>
        </div>

        <div>
          <div class="form-group">
            <label>Incident Title:</label>
            <input
              id="incidentTitle"
              help-anchor="incidentTitle"
              class="form-control"
              [class.ng-valid]="f.summary().valid()"
              [class.ng-invalid]="f.summary().invalid()"
              [formField]="f.summary"
            />
          </div>

          <div class="form-group">
            <label>Incident Description:</label>
            <textarea
              id="incidentBody"
              help-anchor="incidentBody"
              rows="3"
              class="form-control"
              [class.ng-valid]="f.detailsHTML().valid()"
              [class.ng-invalid]="f.detailsHTML().invalid()"
              [formField]="f.detailsHTML"
            ></textarea>
          </div>

          <div class="form-group">
            <label>
              <i class="k-icon k-i-warning me-1"></i>
              Impact:
            </label>
            <select
              help-anchor="impact"
              class="form-control"
              [formField]="f.impact"
            >
              <option value="" disabled selected>Select Impact</option>
              <option value="OrganizationWide">Organization Wide</option>
              <option value="MultipleUsersAffected">
                Multiple Users Affected
              </option>
              <option value="SingleUserAffected">Single User Affected</option>
            </select>
          </div>

          <div class="form-group">
            <label>
              <i class="k-icon k-i-clock me-1"></i>
              Urgency:
            </label>
            <select
              help-anchor="urgency"
              class="form-control"
              [formField]="f.urgency"
            >
              <option value="" disabled selected>Select Urgency</option>
              <option value="High">High</option>
              <option value="Medium">Medium</option>
              <option value="Low">Low</option>
            </select>
          </div>

          <div class="form-group">
            <label>
              <i class="k-icon k-i-categorize me-1"></i>
              Category:
            </label>
            <select
              help-anchor="category"
              class="form-control"
              [formField]="f.category"
            >
              <option value="" disabled selected>Select Category</option>
              @for (category of categories; track category) {
                <option value="{{ category.value }}">
                  {{ category.value }}
                </option>
              }
            </select>
          </div>
        </div>
      }

      @if (isSaving) {
        <div class="d-flex align-items-center justify-content-center">
          <i class="k-icon k-i-loading k-icon-xl"></i>
        </div>
      }
    </div>

    <kendo-dialog-actions>
      <button
        type="button"
        class="k-button k-primary"
        (click)="confirm()"
        [disabled]="!isTicketValid() || isSaving"
      >
        Confirm
      </button>
      <button type="button" class="k-button" (click)="cancel()">Cancel</button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
